import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ImageFallback from '../../common/imageFallback/ImageFallback';

import './Baggage.css';

const I18n = require('i18n-react').default;

const propTypes = {
  id: PropTypes.string.isRequired,
  quantity: PropTypes.number,
  weight: PropTypes.number,
  displayIcon: PropTypes.bool
};

const defaultProps = {
  quantity: 0,
  weight: 0,
  displayIcon: true
};

const GREEN_COLOR = 'green';
const RED_COLOR = 'red';

class Baggage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      baggage_color: null,
      message: null
    };

    this.renderIcon = this.renderIcon.bind(this);
  }

  componentWillMount() {
    let baggage_color, message;
    if (this.props.quantity > 0 || this.props.weight > 0) {
      baggage_color = GREEN_COLOR;

      if (this.props.weight > 0) {
        message = I18n.translate('components.baggage.weight', {
          weight: this.props.weight
        });
      } else if (this.props.quantity && this.props.quantity > 1) {
        message = I18n.translate('components.baggage.quantity.many', {
          quantity: this.props.quantity
        });
      } else {
        message = I18n.translate('components.baggage.quantity.single');
      }
    } else {
      baggage_color = RED_COLOR;
      message = I18n.translate('components.baggage.notIncluded');
    }

    this.setState({
      baggage_color: baggage_color,
      message: message
    });
  }

  renderIcon() {
    if (this.props.displayIcon) {
      return (
        <Col className="Baggage__image" xs={12}>
          <ImageFallback
            className="Baggage__baggageImg"
            src={`styles/img/baggage-${this.state.baggage_color}.svg`}
            alt={`${this.state.baggage_color} luggage icon`}
          />
        </Col>
      );
    }
    return null;
  }

  render() {
    return (
      <div id={`baggage-${this.props.id}`}>
        <Row className="Baggage__content">
          {this.renderIcon()}
          <Col
            className={`Baggage__description ${this.state.baggage_color} ${
              !this.props.displayIcon ? 'no-icon' : ''
            }`}
            xs={12}>
            {this.state.message}
          </Col>
        </Row>
      </div>
    );
  }
}

Baggage.propTypes = propTypes;
Baggage.defaultProps = defaultProps;

export default Baggage;



// WEBPACK FOOTER //
// ./src/components/flightSelection/baggage/Baggage.jsx